// @flow

import Transition from 'react-transition-group/Transition';
import React from 'react';

type Props = {
  visible: boolean,
  children?: any,
}

const duration = 200;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
}

const transitionStyles = {
  entering: { opacity: 0 },
  entered:  { opacity: 1 },
  exiting: { opacity: 1 },
  exited: { opacity: 0 }
};

export const FadeInOut = (props: Props) => {
  const { visible, children } = props;

  return (
    <Transition in={visible} timeout={duration}>
      {(state) => (
        <div style={{
          ...defaultStyle,
          ...transitionStyles[state]
        }}>
          {children}
        </div>
      )}
    </Transition>
  )
}


export default FadeInOut;
